// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DecisionStamp-module__font-s-10___UeXYz {
  font-size: 10px !important;
}

.DecisionStamp-module__font-s-12___RUN7y {
  font-size: 12px !important;
}

.DecisionStamp-module__font-s-13___humfw {
  font-size: 13px !important;
}

.DecisionStamp-module__font-s-14___nLkWu {
  font-size: 14px !important;
}

.DecisionStamp-module__font-s-15___Q9KgO {
  font-size: 15px !important;
}

.DecisionStamp-module__font-s-16___neipY {
  font-size: 16px !important;
}

.DecisionStamp-module__font-s-18___BntGj {
  font-size: 18px !important;
}

.DecisionStamp-module__font-s-20___p1Dn3 {
  font-size: 20px !important;
}

.DecisionStamp-module__font-s-22___JVL3B {
  font-size: 22px !important;
}

.DecisionStamp-module__font-s-28___YqM2F {
  font-size: 28px !important;
}

.DecisionStamp-module__font-w-400___FW30W {
  font-weight: 400 !important;
}

.DecisionStamp-module__font-w-500___tL_JT {
  font-weight: 500 !important;
}

.DecisionStamp-module__font-w-600___aOlpM {
  font-weight: 600 !important;
}

.DecisionStamp-module__font-w-700___YGsnf {
  font-weight: 700 !important;
}

.DecisionStamp-module__p-5___kew8m {
  padding: 5px !important;
}

.DecisionStamp-module__p-12____kSVd {
  padding: 12px !important;
}

.DecisionStamp-module__p-16___jSOQr {
  padding: 16px !important;
}

.DecisionStamp-module__p-30___aC5vS {
  padding: 30px !important;
}

.DecisionStamp-module__p-b-0___xFaeE {
  padding-bottom: 0 !important;
}

.DecisionStamp-module__p-b-5___K00ZB {
  padding-bottom: 5px !important;
}

.DecisionStamp-module__p-b-10___V4dMZ {
  padding-bottom: 10px !important;
}

.DecisionStamp-module__p-b-12___R9ZkR {
  padding-bottom: 12px !important;
}

.DecisionStamp-module__p-b-16___SNa2k {
  padding-bottom: 16px !important;
}

.DecisionStamp-module__p-b-18___2Havt {
  padding-bottom: 18px !important;
}

.DecisionStamp-module__p-b-20___tRuxr {
  padding-bottom: 20px !important;
}

.DecisionStamp-module__p-b-25___NcbdJ {
  padding-bottom: 25px !important;
}

.DecisionStamp-module__p-b-30___JqR9A {
  padding-bottom: 30px !important;
}

.DecisionStamp-module__p-b-50___nO0Ot {
  padding-bottom: 50px !important;
}

.DecisionStamp-module__p-t-0___Mz1HI {
  padding-top: 0 !important;
}

.DecisionStamp-module__p-t-12___TrCSt {
  padding-top: 12px !important;
}

.DecisionStamp-module__p-t-16___sKC6i {
  padding-top: 16px !important;
}

.DecisionStamp-module__p-t-18___xg6NS {
  padding-top: 18px !important;
}

.DecisionStamp-module__p-t-20___gxKdX {
  padding-top: 20px !important;
}

.DecisionStamp-module__p-t-30___iLzn3 {
  padding-top: 30px !important;
}

.DecisionStamp-module__p-t-40___nXepW {
  padding-top: 40px !important;
}

.DecisionStamp-module__p-t-50___hQV9J {
  padding-top: 50px !important;
}

.DecisionStamp-module__p-l-20___TrCD3 {
  padding-left: 20px !important;
}

.DecisionStamp-module__p-l-30___KMR7M {
  padding-left: 30px !important;
}

.DecisionStamp-module__p-l-40___e6fyG {
  padding-left: 40px !important;
}

.DecisionStamp-module__p-r-16___aTYPn {
  padding-right: 16px !important;
}

.DecisionStamp-module__p-r-20___Utjd3 {
  padding-right: 20px !important;
}

.DecisionStamp-module__p-r-30___YxicH {
  padding-right: 30px !important;
}

.DecisionStamp-module__p-r-50___zRdQV {
  padding-right: 50px !important;
}

.DecisionStamp-module__p-r-60___hyjFC {
  padding-right: 60px !important;
}

.DecisionStamp-module__m-b-1___Q7SPc {
  margin-bottom: 1px !important;
}

.DecisionStamp-module__m-b-2___qKMVu {
  margin-bottom: 2px !important;
}

.DecisionStamp-module__m-b-6___zmrJt {
  margin-bottom: 6px !important;
}

.DecisionStamp-module__m-b-8___DXLTt {
  margin-bottom: 8px !important;
}

.DecisionStamp-module__m-b-10___iNTIj {
  margin-bottom: 10px !important;
}

.DecisionStamp-module__m-b-14___G841N {
  margin-bottom: 14px !important;
}

.DecisionStamp-module__m-b-16___cj5Yd {
  margin-bottom: 16px !important;
}

.DecisionStamp-module__m-b-20___almle {
  margin-bottom: 20px !important;
}

.DecisionStamp-module__m-b-22___YpmJs {
  margin-bottom: 22px !important;
}

.DecisionStamp-module__m-b-24___NYaTC {
  margin-bottom: 24px !important;
}

.DecisionStamp-module__m-b-30___jpty6 {
  margin-bottom: 30px !important;
}

.DecisionStamp-module__m-b-32___oZTCf {
  margin-bottom: 32px !important;
}

.DecisionStamp-module__m-b-40___moimC {
  margin-bottom: 40px !important;
}

.DecisionStamp-module__m-t-2___RafDU {
  margin-top: 2px !important;
}

.DecisionStamp-module__m-t-3___YAXVs {
  margin-top: 3px !important;
}

.DecisionStamp-module__m-t-4___PU99p {
  margin-top: 4px !important;
}

.DecisionStamp-module__m-t-5___qq8Lw {
  margin-top: 5px !important;
}

.DecisionStamp-module__m-t-8___gKJqS {
  margin-top: 8px !important;
}

.DecisionStamp-module__m-t-10___y5x7f {
  margin-top: 10px !important;
}

.DecisionStamp-module__m-t-15___KKUyi {
  margin-top: 15px !important;
}

.DecisionStamp-module__m-t-16___MQKLB {
  margin-top: 16px !important;
}

.DecisionStamp-module__m-t-20___yLBhy {
  margin-top: 20px !important;
}

.DecisionStamp-module__m-t-22___d59bx {
  margin-top: 22px !important;
}

.DecisionStamp-module__m-t-30___DfvpG {
  margin-top: 30px !important;
}

.DecisionStamp-module__m-t-32___fGGcy {
  margin-top: 32px !important;
}

.DecisionStamp-module__m-l-auto___qWYSM {
  margin-left: auto !important;
}

.DecisionStamp-module__m-l-4___Pop5T {
  margin-left: 4px !important;
}

.DecisionStamp-module__m-l-5___ys_B0 {
  margin-left: 5px !important;
}

.DecisionStamp-module__m-l-6___J43df {
  margin-left: 6px !important;
}

.DecisionStamp-module__m-l-8___sEqxA {
  margin-left: 8px !important;
}

.DecisionStamp-module__m-l-10___ltT8D {
  margin-left: 10px !important;
}

.DecisionStamp-module__m-l-16___tEX9e {
  margin-left: 16px !important;
}

.DecisionStamp-module__m-l-20___R7sUv {
  margin-left: 20px !important;
}

.DecisionStamp-module__m-l-24___RF4xA {
  margin-left: 24px !important;
}

.DecisionStamp-module__m-l-30___fSp8i {
  margin-left: 30px !important;
}

.DecisionStamp-module__m-l-35___Hmyyr {
  margin-left: 35px !important;
}

.DecisionStamp-module__m-l-40___qfm3Q {
  margin-left: 40px !important;
}

.DecisionStamp-module__m-r-8___dOUWK {
  margin-right: 8px !important;
}

.DecisionStamp-module__m-r-10___kqdDV {
  margin-right: 10px !important;
}

.DecisionStamp-module__m-r-16___sPb_L {
  margin-right: 16px !important;
}

.DecisionStamp-module__m-r-20___e9ptW {
  margin-right: 20px !important;
}

.DecisionStamp-module__m-r-24___UAXfp {
  margin-right: 24px !important;
}

.DecisionStamp-module__m-r-30___Y42m9 {
  margin-right: 30px !important;
}

.DecisionStamp-module__m-r-40___zYKpH {
  margin-right: 40px !important;
}

.DecisionStamp-module__border-r-3___fuwn5 {
  border-radius: 3px !important;
}

.DecisionStamp-module__border-r-4___pymkY {
  border-radius: 4px !important;
}

.DecisionStamp-module__border-r-6___lsqUE {
  border-radius: 6px !important;
}

.DecisionStamp-module__border-r-10___a8_Re {
  border-radius: 10px !important;
}

.DecisionStamp-module__border-r-12___pJXCS {
  border-radius: 12px !important;
}

.DecisionStamp-module__border-r-16____Q1YC {
  border-radius: 16px !important;
}

.DecisionStamp-module__border-r-50___AtAFn {
  border-radius: 50% !important;
}

.DecisionStamp-module__primary-border___RHqMY {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DecisionStamp-module__primary-border-b___XRLuV {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DecisionStamp-module__primary-border-t___tO6Vt {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DecisionStamp-module__primary-border-l___MZ27C {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DecisionStamp-module__primary-border-r___QqvE4 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DecisionStamp-module__secondary-border____dbQo {
  border: 1px solid #637768;
}

.DecisionStamp-module__secondary-border-b___VeSlr {
  border-bottom: 1px solid #637768;
}

.DecisionStamp-module__secondary-border-t___cJoRA {
  border-top: 1px solid #637768;
}

.DecisionStamp-module__secondary-border-l___cHA1P {
  border-left: 1px solid #637768;
}

.DecisionStamp-module__secondary-border-r___yq5Tx {
  border-right: 1px solid #637768;
}

.DecisionStamp-module__gap-0___gvEAy {
  gap: 0 !important;
}

.DecisionStamp-module__gap-2___Wr3NO {
  gap: 2px !important;
}

.DecisionStamp-module__gap-4___us6Ym {
  gap: 4px !important;
}

.DecisionStamp-module__gap-5___vxtdO {
  gap: 5px !important;
}

.DecisionStamp-module__gap-6___Nqlca {
  gap: 6px !important;
}

.DecisionStamp-module__gap-8___Xl7te {
  gap: 8px !important;
}

.DecisionStamp-module__gap-10___hKV7T {
  gap: 10px !important;
}

.DecisionStamp-module__gap-12___NeCeq {
  gap: 12px !important;
}

.DecisionStamp-module__gap-14___eVNLh {
  gap: 14px !important;
}

.DecisionStamp-module__gap-16___McmMI {
  gap: 16px !important;
}

.DecisionStamp-module__gap-18___rt3wo {
  gap: 18px !important;
}

.DecisionStamp-module__gap-20___SAdcu {
  gap: 20px !important;
}

.DecisionStamp-module__gap-24___DR_8J {
  gap: 24px !important;
}

.DecisionStamp-module__gap-26___QZRWm {
  gap: 26px !important;
}

.DecisionStamp-module__gap-30___LMqpM {
  gap: 30px !important;
}

.DecisionStamp-module__gap-32___F1T7w {
  gap: 32px !important;
}

.DecisionStamp-module__gap-40___dQtk4 {
  gap: 40px !important;
}

.DecisionStamp-module__gap-50___jotJI {
  gap: 50px !important;
}

.DecisionStamp-module__flex-1___pQhlu {
  flex: 1;
}

.DecisionStamp-module__flex-none___nyUyh {
  flex: none !important;
}

.DecisionStamp-module__flex-column___yVuBM {
  display: flex;
  flex-direction: column !important;
}

.DecisionStamp-module__flex-row___uDjdT {
  display: flex;
  flex-direction: row !important;
}

.DecisionStamp-module__vertically-centered___YFTD4 {
  display: flex;
  align-items: center !important;
}

.DecisionStamp-module__horizontally-centered___l8HPr {
  display: flex;
  justify-content: center !important;
}

.DecisionStamp-module__horizontally-end___NQfay {
  display: flex;
  justify-content: end !important;
}

.DecisionStamp-module__vertically-start___nL7sc {
  display: flex;
  align-items: start !important;
}

.DecisionStamp-module__space-between___tYWAd {
  display: flex;
  justify-content: space-between !important;
}

.DecisionStamp-module__flex-wrap___H7ZXP {
  flex-wrap: wrap !important;
}

.DecisionStamp-module__height-100___TCHFg {
  height: 100%;
}

.DecisionStamp-module__width-50___EqSQ2 {
  width: 50% !important;
}

.DecisionStamp-module__width-100___o7owr {
  width: 100%;
}

.DecisionStamp-module__cursor-pointer___dYLxw {
  cursor: pointer;
}

.DecisionStamp-module__cursor-not-allowed___dKQGl {
  cursor: not-allowed !important;
}

.DecisionStamp-module__absolute-centered___akdmw {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DecisionStamp-module__absolute___AdXPN {
  position: absolute;
}

.DecisionStamp-module__relative___A0VVO {
  position: relative;
}

.DecisionStamp-module__fixed___LkpsQ {
  position: fixed;
}

.DecisionStamp-module__visible___u9qut {
  opacity: 1;
}

.DecisionStamp-module__invisible___SzThv {
  opacity: 0;
}

.DecisionStamp-module__col-90___n7YSe {
  width: 90% !important;
}

.DecisionStamp-module__col-auto___AXvJj {
  width: auto !important;
}

.DecisionStamp-module__medical-tabs___waXLJ {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DecisionStamp-module__medical-table-new___PmJ3o {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DecisionStamp-module__medical-table-new___PmJ3o:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DecisionStamp-module__medical-table-new___PmJ3o::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DecisionStamp-module__medical-table-new___PmJ3o::-webkit-scrollbar-track {
  display: none;
}
.DecisionStamp-module__medical-table-new___PmJ3o.DecisionStamp-module__no-pagination___CvNI_ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DecisionStamp-module__medical-table-new___PmJ3o.DecisionStamp-module__no-pagination___CvNI_:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DecisionStamp-module__medical-table-new___PmJ3o.DecisionStamp-module__no-pagination___CvNI_::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DecisionStamp-module__medical-table-new___PmJ3o.DecisionStamp-module__no-pagination___CvNI_::-webkit-scrollbar-track {
  display: none;
}

.DecisionStamp-module__medical-table-empty___nF7Cv {
  padding: 14px 40px !important;
}

.DecisionStamp-module__icon-btn___vRvLR {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DecisionStamp-module__search-icon___AWn09 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DecisionStamp-module__disable-select___crxkJ {
  user-select: none;
}

.DecisionStamp-module__break-word___pN7pZ {
  word-break: break-word;
}

.DecisionStamp-module__popup-clear-btn___NeiwK {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DecisionStamp-module__scroll-m-b-20___yUm68 {
  scroll-margin-bottom: 20px;
}

.DecisionStamp-module__stamp___asqab {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.DecisionStamp-module__badge___LBCWJ {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  font-weight: 500;
  line-height: 22px;
  white-space: nowrap;
  border: 1px solid;
  border-radius: 4px;
}

.DecisionStamp-module__neutral___A5sVR {
  background: #f4f4f5;
  border-color: #e4e4e7;
  color: #3f3f46;
}

.DecisionStamp-module__outline___E3U2E {
  background: transparent;
  border-color: #d4d4d8;
  color: #52525b;
}

.DecisionStamp-module__success___i9XWX {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #166534;
}

.DecisionStamp-module__warning___jFx93 {
  background: #fefce8;
  border-color: #fde68a;
  color: #854d0e;
}

.DecisionStamp-module__danger___YppG9 {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}

.DecisionStamp-module__info___zEBou {
  background: #f0f9ff;
  border-color: #bae6fd;
  color: #0369a1;
}

.DecisionStamp-module__note___ueBCo {
  color: #3f3f46;
}

.DecisionStamp-module__when___RRJlF {
  color: #71717a;
}

.DecisionStamp-module__undo___JQFX3 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #18181b;
  text-decoration: underline;
  text-decoration-color: #d4d4d8;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.DecisionStamp-module__undo___JQFX3:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}
.DecisionStamp-module__undo___JQFX3 {
  outline: none;
}
.DecisionStamp-module__undo___JQFX3:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.DecisionStamp-module__undo___JQFX3:disabled, .DecisionStamp-module__undo___JQFX3[aria-disabled=true] {
  color: #a1a1aa;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/DecisionStamp/DecisionStamp.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EEpBE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,sDAAA;AFmrBF;AEjrBE;EACE,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AFmrBJ;AArrBA;EE7BE,aAAA;AFqtBF;AEntBE;EACE,0BAAA;EACA,mBALuB;AF0tB3B;AErrBE;EAEE,cAAA;EACA,eAAA;AFsrBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.stamp {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 8px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 22px;\n  white-space: nowrap;\n  border: 1px solid;\n  border-radius: 4px;\n}\n\n.neutral {\n  background: #f4f4f5;\n  border-color: #e4e4e7;\n  color: #3f3f46;\n}\n\n.outline {\n  background: transparent;\n  border-color: #d4d4d8;\n  color: #52525b;\n}\n\n.success {\n  background: tone-color(success, bg);\n  border-color: tone-color(success, border);\n  color: tone-color(success, text);\n}\n\n.warning {\n  background: tone-color(warning, bg);\n  border-color: tone-color(warning, border);\n  color: tone-color(warning, text);\n}\n\n.danger {\n  background: tone-color(danger, bg);\n  border-color: tone-color(danger, border);\n  color: tone-color(danger, text);\n}\n\n.info {\n  background: tone-color(info, bg);\n  border-color: tone-color(info, border);\n  color: tone-color(info, text);\n}\n\n.note {\n  color: #3f3f46;\n}\n\n.when {\n  color: #71717a;\n}\n\n.undo {\n  @include line-button;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DecisionStamp-module__font-s-10___UeXYz`,
	"fontS12": `DecisionStamp-module__font-s-12___RUN7y`,
	"fontS13": `DecisionStamp-module__font-s-13___humfw`,
	"fontS14": `DecisionStamp-module__font-s-14___nLkWu`,
	"fontS15": `DecisionStamp-module__font-s-15___Q9KgO`,
	"fontS16": `DecisionStamp-module__font-s-16___neipY`,
	"fontS18": `DecisionStamp-module__font-s-18___BntGj`,
	"fontS20": `DecisionStamp-module__font-s-20___p1Dn3`,
	"fontS22": `DecisionStamp-module__font-s-22___JVL3B`,
	"fontS28": `DecisionStamp-module__font-s-28___YqM2F`,
	"fontW400": `DecisionStamp-module__font-w-400___FW30W`,
	"fontW500": `DecisionStamp-module__font-w-500___tL_JT`,
	"fontW600": `DecisionStamp-module__font-w-600___aOlpM`,
	"fontW700": `DecisionStamp-module__font-w-700___YGsnf`,
	"p5": `DecisionStamp-module__p-5___kew8m`,
	"p12": `DecisionStamp-module__p-12____kSVd`,
	"p16": `DecisionStamp-module__p-16___jSOQr`,
	"p30": `DecisionStamp-module__p-30___aC5vS`,
	"pB0": `DecisionStamp-module__p-b-0___xFaeE`,
	"pB5": `DecisionStamp-module__p-b-5___K00ZB`,
	"pB10": `DecisionStamp-module__p-b-10___V4dMZ`,
	"pB12": `DecisionStamp-module__p-b-12___R9ZkR`,
	"pB16": `DecisionStamp-module__p-b-16___SNa2k`,
	"pB18": `DecisionStamp-module__p-b-18___2Havt`,
	"pB20": `DecisionStamp-module__p-b-20___tRuxr`,
	"pB25": `DecisionStamp-module__p-b-25___NcbdJ`,
	"pB30": `DecisionStamp-module__p-b-30___JqR9A`,
	"pB50": `DecisionStamp-module__p-b-50___nO0Ot`,
	"pT0": `DecisionStamp-module__p-t-0___Mz1HI`,
	"pT12": `DecisionStamp-module__p-t-12___TrCSt`,
	"pT16": `DecisionStamp-module__p-t-16___sKC6i`,
	"pT18": `DecisionStamp-module__p-t-18___xg6NS`,
	"pT20": `DecisionStamp-module__p-t-20___gxKdX`,
	"pT30": `DecisionStamp-module__p-t-30___iLzn3`,
	"pT40": `DecisionStamp-module__p-t-40___nXepW`,
	"pT50": `DecisionStamp-module__p-t-50___hQV9J`,
	"pL20": `DecisionStamp-module__p-l-20___TrCD3`,
	"pL30": `DecisionStamp-module__p-l-30___KMR7M`,
	"pL40": `DecisionStamp-module__p-l-40___e6fyG`,
	"pR16": `DecisionStamp-module__p-r-16___aTYPn`,
	"pR20": `DecisionStamp-module__p-r-20___Utjd3`,
	"pR30": `DecisionStamp-module__p-r-30___YxicH`,
	"pR50": `DecisionStamp-module__p-r-50___zRdQV`,
	"pR60": `DecisionStamp-module__p-r-60___hyjFC`,
	"mB1": `DecisionStamp-module__m-b-1___Q7SPc`,
	"mB2": `DecisionStamp-module__m-b-2___qKMVu`,
	"mB6": `DecisionStamp-module__m-b-6___zmrJt`,
	"mB8": `DecisionStamp-module__m-b-8___DXLTt`,
	"mB10": `DecisionStamp-module__m-b-10___iNTIj`,
	"mB14": `DecisionStamp-module__m-b-14___G841N`,
	"mB16": `DecisionStamp-module__m-b-16___cj5Yd`,
	"mB20": `DecisionStamp-module__m-b-20___almle`,
	"mB22": `DecisionStamp-module__m-b-22___YpmJs`,
	"mB24": `DecisionStamp-module__m-b-24___NYaTC`,
	"mB30": `DecisionStamp-module__m-b-30___jpty6`,
	"mB32": `DecisionStamp-module__m-b-32___oZTCf`,
	"mB40": `DecisionStamp-module__m-b-40___moimC`,
	"mT2": `DecisionStamp-module__m-t-2___RafDU`,
	"mT3": `DecisionStamp-module__m-t-3___YAXVs`,
	"mT4": `DecisionStamp-module__m-t-4___PU99p`,
	"mT5": `DecisionStamp-module__m-t-5___qq8Lw`,
	"mT8": `DecisionStamp-module__m-t-8___gKJqS`,
	"mT10": `DecisionStamp-module__m-t-10___y5x7f`,
	"mT15": `DecisionStamp-module__m-t-15___KKUyi`,
	"mT16": `DecisionStamp-module__m-t-16___MQKLB`,
	"mT20": `DecisionStamp-module__m-t-20___yLBhy`,
	"mT22": `DecisionStamp-module__m-t-22___d59bx`,
	"mT30": `DecisionStamp-module__m-t-30___DfvpG`,
	"mT32": `DecisionStamp-module__m-t-32___fGGcy`,
	"mLAuto": `DecisionStamp-module__m-l-auto___qWYSM`,
	"mL4": `DecisionStamp-module__m-l-4___Pop5T`,
	"mL5": `DecisionStamp-module__m-l-5___ys_B0`,
	"mL6": `DecisionStamp-module__m-l-6___J43df`,
	"mL8": `DecisionStamp-module__m-l-8___sEqxA`,
	"mL10": `DecisionStamp-module__m-l-10___ltT8D`,
	"mL16": `DecisionStamp-module__m-l-16___tEX9e`,
	"mL20": `DecisionStamp-module__m-l-20___R7sUv`,
	"mL24": `DecisionStamp-module__m-l-24___RF4xA`,
	"mL30": `DecisionStamp-module__m-l-30___fSp8i`,
	"mL35": `DecisionStamp-module__m-l-35___Hmyyr`,
	"mL40": `DecisionStamp-module__m-l-40___qfm3Q`,
	"mR8": `DecisionStamp-module__m-r-8___dOUWK`,
	"mR10": `DecisionStamp-module__m-r-10___kqdDV`,
	"mR16": `DecisionStamp-module__m-r-16___sPb_L`,
	"mR20": `DecisionStamp-module__m-r-20___e9ptW`,
	"mR24": `DecisionStamp-module__m-r-24___UAXfp`,
	"mR30": `DecisionStamp-module__m-r-30___Y42m9`,
	"mR40": `DecisionStamp-module__m-r-40___zYKpH`,
	"borderR3": `DecisionStamp-module__border-r-3___fuwn5`,
	"borderR4": `DecisionStamp-module__border-r-4___pymkY`,
	"borderR6": `DecisionStamp-module__border-r-6___lsqUE`,
	"borderR10": `DecisionStamp-module__border-r-10___a8_Re`,
	"borderR12": `DecisionStamp-module__border-r-12___pJXCS`,
	"borderR16": `DecisionStamp-module__border-r-16____Q1YC`,
	"borderR50": `DecisionStamp-module__border-r-50___AtAFn`,
	"primaryBorder": `DecisionStamp-module__primary-border___RHqMY`,
	"primaryBorderB": `DecisionStamp-module__primary-border-b___XRLuV`,
	"primaryBorderT": `DecisionStamp-module__primary-border-t___tO6Vt`,
	"primaryBorderL": `DecisionStamp-module__primary-border-l___MZ27C`,
	"primaryBorderR": `DecisionStamp-module__primary-border-r___QqvE4`,
	"secondaryBorder": `DecisionStamp-module__secondary-border____dbQo`,
	"secondaryBorderB": `DecisionStamp-module__secondary-border-b___VeSlr`,
	"secondaryBorderT": `DecisionStamp-module__secondary-border-t___cJoRA`,
	"secondaryBorderL": `DecisionStamp-module__secondary-border-l___cHA1P`,
	"secondaryBorderR": `DecisionStamp-module__secondary-border-r___yq5Tx`,
	"gap0": `DecisionStamp-module__gap-0___gvEAy`,
	"gap2": `DecisionStamp-module__gap-2___Wr3NO`,
	"gap4": `DecisionStamp-module__gap-4___us6Ym`,
	"gap5": `DecisionStamp-module__gap-5___vxtdO`,
	"gap6": `DecisionStamp-module__gap-6___Nqlca`,
	"gap8": `DecisionStamp-module__gap-8___Xl7te`,
	"gap10": `DecisionStamp-module__gap-10___hKV7T`,
	"gap12": `DecisionStamp-module__gap-12___NeCeq`,
	"gap14": `DecisionStamp-module__gap-14___eVNLh`,
	"gap16": `DecisionStamp-module__gap-16___McmMI`,
	"gap18": `DecisionStamp-module__gap-18___rt3wo`,
	"gap20": `DecisionStamp-module__gap-20___SAdcu`,
	"gap24": `DecisionStamp-module__gap-24___DR_8J`,
	"gap26": `DecisionStamp-module__gap-26___QZRWm`,
	"gap30": `DecisionStamp-module__gap-30___LMqpM`,
	"gap32": `DecisionStamp-module__gap-32___F1T7w`,
	"gap40": `DecisionStamp-module__gap-40___dQtk4`,
	"gap50": `DecisionStamp-module__gap-50___jotJI`,
	"flex1": `DecisionStamp-module__flex-1___pQhlu`,
	"flexNone": `DecisionStamp-module__flex-none___nyUyh`,
	"flexColumn": `DecisionStamp-module__flex-column___yVuBM`,
	"flexRow": `DecisionStamp-module__flex-row___uDjdT`,
	"verticallyCentered": `DecisionStamp-module__vertically-centered___YFTD4`,
	"horizontallyCentered": `DecisionStamp-module__horizontally-centered___l8HPr`,
	"horizontallyEnd": `DecisionStamp-module__horizontally-end___NQfay`,
	"verticallyStart": `DecisionStamp-module__vertically-start___nL7sc`,
	"spaceBetween": `DecisionStamp-module__space-between___tYWAd`,
	"flexWrap": `DecisionStamp-module__flex-wrap___H7ZXP`,
	"height100": `DecisionStamp-module__height-100___TCHFg`,
	"width50": `DecisionStamp-module__width-50___EqSQ2`,
	"width100": `DecisionStamp-module__width-100___o7owr`,
	"cursorPointer": `DecisionStamp-module__cursor-pointer___dYLxw`,
	"cursorNotAllowed": `DecisionStamp-module__cursor-not-allowed___dKQGl`,
	"absoluteCentered": `DecisionStamp-module__absolute-centered___akdmw`,
	"absolute": `DecisionStamp-module__absolute___AdXPN`,
	"relative": `DecisionStamp-module__relative___A0VVO`,
	"fixed": `DecisionStamp-module__fixed___LkpsQ`,
	"visible": `DecisionStamp-module__visible___u9qut`,
	"invisible": `DecisionStamp-module__invisible___SzThv`,
	"col90": `DecisionStamp-module__col-90___n7YSe`,
	"colAuto": `DecisionStamp-module__col-auto___AXvJj`,
	"medicalTabs": `DecisionStamp-module__medical-tabs___waXLJ`,
	"medicalTableNew": `DecisionStamp-module__medical-table-new___PmJ3o`,
	"noPagination": `DecisionStamp-module__no-pagination___CvNI_`,
	"medicalTableEmpty": `DecisionStamp-module__medical-table-empty___nF7Cv`,
	"iconBtn": `DecisionStamp-module__icon-btn___vRvLR`,
	"searchIcon": `DecisionStamp-module__search-icon___AWn09`,
	"disableSelect": `DecisionStamp-module__disable-select___crxkJ`,
	"breakWord": `DecisionStamp-module__break-word___pN7pZ`,
	"popupClearBtn": `DecisionStamp-module__popup-clear-btn___NeiwK`,
	"scrollMB20": `DecisionStamp-module__scroll-m-b-20___yUm68`,
	"stamp": `DecisionStamp-module__stamp___asqab`,
	"badge": `DecisionStamp-module__badge___LBCWJ`,
	"neutral": `DecisionStamp-module__neutral___A5sVR`,
	"outline": `DecisionStamp-module__outline___E3U2E`,
	"success": `DecisionStamp-module__success___i9XWX`,
	"warning": `DecisionStamp-module__warning___jFx93`,
	"danger": `DecisionStamp-module__danger___YppG9`,
	"info": `DecisionStamp-module__info___zEBou`,
	"note": `DecisionStamp-module__note___ueBCo`,
	"when": `DecisionStamp-module__when___RRJlF`,
	"undo": `DecisionStamp-module__undo___JQFX3`
};
module.exports = ___CSS_LOADER_EXPORT___;
